module.exports = __webpack_public_path__ + "media/img/pages/companies/duotec-0cedcd3947d8ee2b05d7e535e7135716.png";